export default {
  blue: ({ disabled }) => {
    let bg = 'white';
    let textColor = 'primary.default';
    const borderColor = 'gray.300';

    if (disabled) {
      textColor = 'gray.400';
      bg = 'gray.150';
    }
    return ({
      borderRadius: '5px',
      border: !disabled && '1px',
      textColor: `${textColor}`,
      color: `${borderColor}`,
      bg: `${bg}`,
      _hover: !disabled && { borderColor: 'primary.900', color: 'primary.900' },
      _active: !disabled && { borderColor: 'primary.1000', color: 'primary.1000' },
    });
  },
  teal: ({ disabled }) => {
    let bg = 'white';
    let textColor = 'secondary.default';
    let borderColor = 'gray.300';

    if (disabled) {
      textColor = 'gray.400';
      bg = 'gray.150';
      borderColor = 'gray.150';
    }
    return ({
      borderRadius: '5px',
      border: !disabled && '1px',
      color: `${textColor}`,
      borderColor: `${borderColor}`,
      bg: `${bg}`,
      _hover: !disabled && { borderColor: 'secondary.700', color: 'secondary.700' },
      _active: !disabled && { borderColor: 'secondary.1000', color: 'secondary.1000' },
    });
  },
};
